import { createAction } from "@reduxjs/toolkit";

// add actions related to the group
export const selectProject = createAction("SET_PROJECT");
export const fetchSIngleProjectAction = createAction("FETCH_SINGLE_PROJECT");
// export const getRoles = createAction("GET_ROLES");
//export const saveUser = createAction("SAVE_USER");
